import { render, staticRenderFns } from "./office-new-user.vue?vue&type=template&id=ad6eb714&scoped=true&lang=pug"
import script from "./office-new-user.vue?vue&type=script&lang=ts"
export * from "./office-new-user.vue?vue&type=script&lang=ts"
import style0 from "./office-new-user.vue?vue&type=style&index=0&id=ad6eb714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6eb714",
  null
  
)

export default component.exports